import { render, staticRenderFns } from "./recover-password.vue?vue&type=template&id=92c56290&scoped=true&"
import script from "./recover-password.vue?vue&type=script&lang=js&"
export * from "./recover-password.vue?vue&type=script&lang=js&"
import style0 from "./recover-password.vue?vue&type=style&index=0&id=92c56290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c56290",
  null
  
)

export default component.exports